import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Box,
  Dropdown,
  ListGroup,
  ListItem,
} from '@cubeyou-team/hx-react-components';

import { QueryBuilderConstants } from 'src/modules/query-builder/constants';

const StyledQueryOperator = styled.button`
  border: 2px solid ${props => props.colors && props.colors[0]};
  background-color: ${props => props.theme.colors.light};
  padding: 4px 8px;
  font-size: ${props => props.theme.size.small};
  border-radius: 8px;
  min-width: 68px;
  font-weight: 400;
  cursor: pointer;
  height: auto;
  &:active,
  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    background-color: ${props => props.colors && props.colors[1]};
  }
`;

const QueryOperatorsList = ({
  availableOperators,
  selectedOperator,
  onOperatorSelected,
}) => {
  return (
    <Box pT="small" pB="xsmall" pX="small">
      <ListGroup
        direction="column"
        size="xsmall"
        halign="left"
        items={availableOperators.map(operator => (
          <ListItem
            text={operator.label}
            isActive={selectedOperator === operator.id}
            onClick={() => onOperatorSelected(operator.id)}
          />
        ))}
      />
    </Box>
  );
};

const QueryOperator = ({
  operator,
  onOperatorChange,
  onHighlightOperator,
  level,
  availableOperators,
}) => {
  const [isDropDownOpen, SetIsDropDownOpen] = useState(false);

  const safeLevel = level >= 0 ? level : 0;
  const operatorColors =
    QueryBuilderConstants.groupOperatorColors[safeLevel % 7];

  const selectedOperatorLabel = useMemo(() => {
    const op = availableOperators.find(o => o.id === operator);
    return op?.label ?? operator ?? '';
  }, [operator, availableOperators]);

  return (
    <Dropdown
      position="right"
      isOpen={isDropDownOpen}
      onClickOutside={() => {
        SetIsDropDownOpen(false);
      }}
      content={
        <QueryOperatorsList
          availableOperators={availableOperators}
          selectedOperator={operator}
          onOperatorSelected={selectedOperator => {
            SetIsDropDownOpen(false);
            onOperatorChange(selectedOperator);
          }}
        />
      }
    >
      <StyledQueryOperator
        onClick={() => {
          SetIsDropDownOpen(!isDropDownOpen);
        }}
        colors={operatorColors}
        onMouseOver={() => {
          onHighlightOperator && onHighlightOperator(true);
        }}
        onMouseLeave={() => {
          onHighlightOperator && onHighlightOperator(false);
        }}
      >
        {selectedOperatorLabel}
      </StyledQueryOperator>
    </Dropdown>
  );
};

QueryOperator.propTypes = {
  operator: PropTypes.string,
  onOperatorChange: PropTypes.func,
};

export default QueryOperator;
